import React, { useState, useEffect } from 'react';
import { Phone, X } from 'lucide-react';

export default function IncomingCallModal({ isOpen, onClose, onSubmit, darkMode, recordingFile }) {
  const [clientName, setClientName] = useState('');

  const bg = darkMode ? 'bg-slate-950' : 'bg-white';
  const text = darkMode ? 'text-slate-50' : 'text-slate-900';
  const textMuted = darkMode ? 'text-slate-400' : 'text-slate-600';
  const border = darkMode ? 'border-slate-800' : 'border-slate-200';

  // Focus automatique sur l'input quand la modal s'ouvre
  useEffect(() => {
    if (isOpen) {
      const input = document.getElementById('incoming-call-client-input');
      if (input) {
        setTimeout(() => input.focus(), 100);
      }
    }
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (clientName.trim()) {
      onSubmit(clientName.trim());
      setClientName('');
    }
  };

  const handleSkip = () => {
    onSubmit('Non mentionné');
    setClientName('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 animate-fadeIn">
      <div 
        className={`${bg} ${text} rounded-lg shadow-2xl max-w-lg w-full mx-4 p-6 animate-slideIn border-2 border-green-500`}>
        
        {/* Header avec animation */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-green-600 rounded-full animate-pulse">
              <Phone size={28} className="text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold">📞 Appel entrant</h2>
              <p className={`text-sm ${textMuted}`}>Enregistrement en cours...</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className={`p-2 rounded-lg hover:bg-slate-800 transition ${textMuted}`}>
            <X size={20} />
          </button>
        </div>

        {/* Info fichier */}
        {recordingFile && (
          <div className={`mb-4 p-3 rounded-lg bg-blue-900/20 border ${border}`}>
            <p className={`text-xs ${textMuted}`}>
              <strong>Fichier :</strong> {recordingFile}
            </p>
          </div>
        )}

        {/* Formulaire */}
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className={`block text-lg font-medium mb-3 ${text}`}>
              Nom du client
            </label>
            <input
              id="incoming-call-client-input"
              type="text"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              placeholder="Tapez le nom du client..."
              className={`w-full px-4 py-4 text-lg rounded-lg border-2 ${border} ${bg} ${text} outline-none focus:border-green-600 transition`}
              autoComplete="off"
            />
            <p className={`mt-2 text-sm ${textMuted}`}>
              💡 Appuyez sur <kbd className="px-2 py-1 bg-slate-700 rounded">Entrée</kbd> pour valider rapidement
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={handleSkip}
              className={`flex-1 px-4 py-3 border-2 ${border} rounded-lg font-medium hover:bg-slate-800 transition text-sm`}>
              Passer (Non mentionné)
            </button>
            <button
              type="submit"
              disabled={!clientName.trim()}
              className="flex-1 px-4 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition disabled:bg-gray-600 disabled:cursor-not-allowed text-lg">
              ✓ Valider
            </button>
          </div>
        </form>

        {/* Note */}
        <div className={`mt-4 p-3 rounded-lg bg-slate-800/30 border ${border}`}>
          <p className={`text-xs ${textMuted} text-center`}>
            ⚡ La fiche sera automatiquement créée avec ce client à la fin de l'appel
          </p>
        </div>
      </div>
    </div>
  );
}